<div class="dialog-container" [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <h1 mat-dialog-title class="dialog-title" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <span class="title">
      {{ sTitle }} </span
    ><span *ngIf="isWarning" class="warning">!</span>
  </h1>

  <div class="content-wrapper">
    <div fxLayout="row" class="content">
      <div>
        <p>
          <span *ngIf="isWarning" class="warning">{{ warningMessage }}</span>{{ sMessage }}
        </p>
        <div *ngIf="missingFields" class="missingFields">
          <ul>
            <li *ngFor="let field of missingFields">{{ field.fieldName }}</li>
          </ul>
        </div>
        <div *ngIf="invalidFields" class="invalidFields">
          <ul>
            <li *ngFor="let field of invalidFields">{{ field }}</li>
          </ul>
        </div>
        <div *ngIf="errors" class="errors">
          <ul>
            <li *ngFor="let field of errors">{{ field }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" class="actions">
    <button
      mat-button
      class="btn-action"
      vrm-button
      (click)="doAction()"
      style="color: white; padding-right: 0; text-transform: uppercase"
    >
      {{ actionText }}
    </button>
  </div>
</div>
